module.exports = __webpack_public_path__ + "static/media/textIcon.e7735fbf.svg";